(() => {
  if (window.__FAJ_B2B_SERVICE_AGREEMENTS_V2__) return;
  window.__FAJ_B2B_SERVICE_AGREEMENTS_V2__ = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-fajb2b-open-booking]');
    if (!trigger) return;

    event.preventDefault();

    /*
     * Reuse the existing booking form from the FAJ service-product main
     * section. Clicking its real opener preserves the V11 modal lifecycle:
     * form reset, success-state reset, dialog opening, and page-scroll lock.
     */
    const serviceSection = document.querySelector('[data-fajsp]');
    const bookingOpener = serviceSection?.querySelector(
      '[data-fajsp-open-booking]'
    );

    if (bookingOpener) {
      bookingOpener.click();
      return;
    }

    /*
     * Optional fallback for pages where the service-product main section
     * is missing or its booking action is configured as an external page.
     */
    const fallbackUrl = trigger.dataset.fallbackUrl?.trim();

    if (fallbackUrl) {
      window.location.assign(fallbackUrl);
      return;
    }

    console.warn(
      'FAJ B2B enquiry: the service-product booking form was not found.'
    );
  });
})();
